<template>
    <div class="app-code-editor">
        <div class="app-code-editor__code">
            <textarea
                ref="editor"
                :class="{ 'is-invalid': validationErrors.length }"
                v-model="internalValue"
                @keydown="checkKeys"
                :rows="rows"
                :cols="cols"
                :placeholder="placeholder"
                :maxlength=this.editorMaxCharacterLimit
                @change="onChange($event)">
            </textarea>
        </div>
        <div class="app-code-editor__errors"
            v-if="validationErrors.length">
            <ul>
                <li class="inline-message is--error" v-for="(error, index) in validationErrors" :key="`error-${index}`">Validation Error: {{ error.message }}</li>
            </ul>
        </div>
        <p class="app-code-editor__character-count">
            Character count: {{ getFieldCharacterCount() }}
        </p>
    </div>
</template>

<script>
import _ from 'lodash'
import validators from '../helpers/validators'

export default {
    props: {
        value: {
            type: String,
            default: ''
        },
        language: {
            type: String,
            default: 'scss'
        },
        validation: {
            type: Boolean,
            default: true
        },
        rows: [Number, String],
        cols: [Number, String],
        placeholder: [String]
    },
    data () {
        return {
            internalValue: this.value || '',
            validationErrors: [],
            selectionStart: 0,
            selectionEnd: 0,
            editorMaxCharacterLimit:250000
        }
    },
    watch: {
        value (value) {
            this.internalValue = value
        }
    },
    methods: {
        reset () {
            this.internalValue = this.value
            this.editorCurrentCharacterCount = this.internalValue.length
        },
        checkKeys (e) {
            const keyCode = e.keyCode || e.which

            // capture tab key
            if (keyCode === 9) {
                e.preventDefault()
                this.insert('  ')
            }
        },
        getValue () {
            return this.internalValue
        },
        insert (value) {
            this.$refs['editor'].focus()
            document.execCommand('insertText', false, value);
        },
        saveSelection (e) {
            this.selectionStart = this.$refs['editor'].selectionStart
            this.selectionEnd = this.$refs['editor'].selectionEnd
        },
        restoreSelection (e) {
            this.$refs['editor'].setSelectionRange(this.selectionStart, this.selectionEnd)
        },
        clearErrors () {
            this.validationErrors = []
        },
        getFieldCharacterCount () {
            let str = this.internalValue.length.toLocaleString()  + '/' + this.editorMaxCharacterLimit.toLocaleString()
            return str
        },
        onChange (event) {
            this.clearErrors()

            if (this.validation) {
                const validatorFn = validators[this.language]
                if (_.isFunction(validatorFn)) {
                    const { success, error } = validatorFn(this.internalValue)

                    if (!success) {
                        // alert(`Validation failed for ${this.language} syntax.`)
                        console.error(error)
                        this.$refs['editor'].focus()
                        this.validationErrors = [error]
                        return
                    }
                }
            }

            this.$emit('change', event)
        }
    },
    mounted () {
        this.$refs['editor'].addEventListener('blur', this.saveSelection)
        this.$refs['editor'].addEventListener('focus', this.restoreSelection)
    }
}
</script>
